interface PagerProps {
  page: number;        // 1-based current page
  totalPages: number;
  onPage: (page: number) => void;
  disabled?: boolean;
}

// Compact pagination bar (First / Prev / "Page X of Y" / Next / Last). Renders
// nothing when there is a single page.
export default function Pager({ page, totalPages, onPage, disabled }: PagerProps) {
  if (totalPages <= 1) return null;

  const btn = (label: string, target: number, enabled: boolean) => (
    <button
      onClick={() => onPage(target)}
      disabled={disabled || !enabled}
      style={{
        background: 'transparent',
        border: '1px solid var(--border-color)',
        color: enabled && !disabled ? 'var(--text-color)' : '#555',
        borderRadius: '4px',
        padding: '0.3rem 0.6rem',
        cursor: enabled && !disabled ? 'pointer' : 'not-allowed',
        fontFamily: 'monospace',
        fontSize: '0.8rem',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '0.5rem', padding: '0.75rem', flexWrap: 'wrap',
      fontFamily: 'monospace', fontSize: '0.8rem', color: 'var(--text-muted)',
    }}>
      {btn('« First', 1, page > 1)}
      {btn('‹ Prev', page - 1, page > 1)}
      <span style={{ padding: '0 0.5rem' }}>Page {page} of {totalPages}</span>
      {btn('Next ›', page + 1, page < totalPages)}
      {btn('Last »', totalPages, page < totalPages)}
    </div>
  );
}
